import { render, staticRenderFns } from "./ReservationPageAdd.vue?vue&type=template&id=023890d1&scoped=true"
import script from "./ReservationPageAdd.vue?vue&type=script&lang=js"
export * from "./ReservationPageAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023890d1",
  null
  
)

export default component.exports